<template>
  <OptionsList :active="active" :select="select" :options="options" />
</template>

<script setup>
import OptionsList from "@/pages/ListingsPage/filters/mobile/OptionsList.vue"

let options = [{ title: "Ready to hang", value: "ready_to_hang", check_value: "ready_to_hang" }]
if (window.config.userSignedIn)
  options = [...options, { title: "Artists I follow", value: "from_followeds", check_value: "from_followeds" }]
options = [...options, { title: "Exclude sold", value: "availability", check_value: "for_sale_web" }]

defineExpose({
  options,
})
</script>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "CheckboxFilterOptions",
  methods: {
    fetchOption(value) {
      return this.options.find((option) => option.value === value)
    },
    select(value) {
      const { check_value } = this.fetchOption(value)
      this.mergeFilter({
        [value]: this[value] === check_value ? this.defaultUncheckValue(this[value]) : check_value,
      })
    },
    defaultUncheckValue(check_value) {
      if (typeof check_value == "boolean") return !check_value

      return "all"
    },
    active(value) {
      const { check_value } = this.fetchOption(value)
      return this[value] === check_value
    },
    ...mapActions("filter", ["mergeFilter"]),
  },
  computed: {
    ...mapState("filter", {
      availability: ({ filters }) => filters.availability,
      ready_to_hang: ({ filters }) => filters.ready_to_hang,
      from_followeds: ({ filters }) => filters.from_followeds,
    }),
  },
}
</script>
